import error from './error';
import success from './success';
import warning from './warning';
import informational from './informational';
import chevronLeft from './chevron-left';
import iconClose from './icon-close';
import iconEdit from './icon-edit';
import dropdownArrow from './dropdown-arrow';
import pinLocationOn from './pin-location-on';
import iconClock from './icon-clock';
import accessibilityIcon from './accessibility-icon';
import iconNext from './icon-next';
import iconPrevious from './icon-previous';
import iconNewWindow from './icon-new-window';
import chevronRight from './chevron-right';
import iconMenu from './icon-menu';

export default {
  errorSVG: error,
  successSVG: success,
  warningSVG: warning,
  informationalSVG: informational,
  chevronLeftSVG: chevronLeft,
  chevronRightSVG: chevronRight,
  iconCloseSVG: iconClose,
  iconEditSVG: iconEdit,
  dropdownArrowSVG: dropdownArrow,
  pinLocationOnSVG: pinLocationOn,
  iconClockSVG: iconClock,
  accessibilityIconSVG: accessibilityIcon,
  iconNextSVG: iconNext,
  iconPreviousSVG: iconPrevious,
  iconNewWindowSVG: iconNewWindow,
  iconMenuSVG: iconMenu,
};
